/**
 * 加盟店側-契約者検索入力フォーム
 * メモ：入力フォームを表示する
 */
import React from "react";

import clsx from "clsx";
import {
  FormControl,
  FormLabel,
  FormControlLabel,
  makeStyles,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
} from "@material-ui/core";

import {
  formStyles,
  checkboxStyles,
} from "../../../../common/components/styles";

import { ContractorSearchCondition } from "../../types";

import { GUEST_COLOR, FONT } from "../../../../../constants/common";

import CustomTextField from "../../../../common/components/atoms/CustomTextField";
import PatternMatchChip from "../../../../common/components/atoms/PatternMatchChip";
import VariableCustomCheckbox from "../../../../common/components/atoms/VariableCustomCheckbox";

const useStyles = makeStyles(() => ({
  label: {
    width: 800,
    textAlign: "left",
    padding: "0!important",
    height: 36,
  },
  attention: {
    fontSize: "0.7rem",
    textAlign: "left",
    fontFamily: FONT,
    marginTop: 0,
  },
  table: {
    width: 800,
    minWidth: 800,
  },
  td: {
    padding: 1,
    backgroundColor: "#fff",
    color: "#000!important",
    borderTop: "1px solid #d2d5d8",
    borderBottom: "1px solid #d2d5d8",
    borderRight: "1px solid #d2d5d8",
    width: 400,
  },
  th: {
    padding: 0,
    fontFamily: FONT,
    backgroundColor: "#fff",
    color: "#000!important",
    width: 200,
    border: "1px solid #d2d5d8",
    position: "relative",
    paddingLeft: 20,
  },
  checkbox: {
    margin: "10px 20px",
  },
}));

// 検索条件フォーム設定
const contractorSearchFormData = [
  {
    name: "会社名",
    formData: "companyName",
    matchType: "部分一致",
  },
  {
    name: "法人番号",
    formData: "corporateNum",
    matchType: "前方一致",
  },
  {
    name: "加盟店コード",
    formData: "customerCode",
    matchType: "前方一致",
  },
  {
    name: "加盟店名",
    formData: "customerName",
    matchType: "部分一致",
  },
  {
    name: "加盟店電話番号",
    formData: "customerPhoneNum",
    matchType: "完全一致",
  },
  {
    name: "解約済みの契約者",
    formData: "contractorTerminationFlag",
    matchType: "",
  },
];

// 契約者検索入力フォームのインターフェース
interface Props {
  searchCondition: ContractorSearchCondition;
  setSearchCondition: React.Dispatch<
    React.SetStateAction<ContractorSearchCondition>
  >;
}

// 検索条件フォーム表示
const ContractorSearchConditionForm: React.FC<Props> = (props: Props) => {
  const classes = useStyles();
  const formClasses = formStyles({
    color: GUEST_COLOR.base,
    backgroundColor: GUEST_COLOR.primary,
  });
  const checkboxClasses = checkboxStyles({
    backgroundColor: GUEST_COLOR.primary,
  });

  const { searchCondition, setSearchCondition } = props;

  return (
    <FormControl className={formClasses.form}>
      <FormLabel className={clsx(formClasses.formLabel, classes.label)}>
        契約者検索
      </FormLabel>
      <TableContainer>
        <Table
          className={clsx(formClasses.table, classes.table)}
          aria-label="simple table"
        >
          <TableBody>
            {contractorSearchFormData.map((formItem) => (
              <TableRow key={formItem.name}>
                <TableCell
                  align="left"
                  className={clsx(formClasses.th, classes.th)}
                >
                  {formItem.name}
                  {formItem.matchType && (
                    <PatternMatchChip
                      left={153}
                      top="24%"
                      text={formItem.matchType}
                    />
                  )}
                </TableCell>
                <TableCell align="left" className={classes.td}>
                  {/* フォーム表示 */}
                  {/* 解約済み含むチェックボックス  */}
                  {formItem.formData === "contractorTerminationFlag" && (
                    <FormControlLabel
                      className={clsx(
                        checkboxClasses.checkbox,
                        classes.checkbox
                      )}
                      control={
                        <VariableCustomCheckbox
                          name={formItem.name}
                          value={formItem.formData}
                          checked={searchCondition.contractorTerminationFlag}
                          onChange={() =>
                            setSearchCondition({
                              ...searchCondition,
                              contractorTerminationFlag:
                                !searchCondition.contractorTerminationFlag,
                            })
                          }
                        />
                      }
                      label="含む"
                    />
                  )}
                  {/* その他の項目 */}
                  {formItem.formData !== "contractorTerminationFlag" && (
                    <CustomTextField
                      value={String(
                        searchCondition[
                          formItem.formData as keyof ContractorSearchCondition
                        ]
                      )}
                      onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
                        setSearchCondition({
                          ...searchCondition,
                          [formItem.formData]: e.target.value,
                        })
                      }
                    />
                  )}
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
    </FormControl>
  );
};

export default ContractorSearchConditionForm;
